import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, EffectCards } from 'swiper/modules';
import { FaImage } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/effect-cards';
import * as S from './GallerySwiper.styles';

/**
 * Reusable card gallery component built with Swiper.
 */
const GallerySwiper = ({ images = [] }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!images || images.length === 0) return null;

  return (
    <S.GalleryContainer>
      <S.MainSwiperWrapper>
        <Swiper
          effect="cards"
          grabCursor={true}
          cardsEffect={{
            perSlideOffset: isMobile ? 8 : 12,
            perSlideRotate: isMobile ? 2 : 3,
            rotate: true,
            slideShadows: false,
          }}
          modules={[Keyboard, EffectCards]}
          keyboard={{ enabled: true }}
          centeredSlides={true}
          className="main-swiper"
        >
          {images.map((img, idx) => (
            <SwiperSlide key={idx}>
              {img.src ? (
                <S.SlideImage
                  src={img.src}
                  alt={img.alt || `Gallery image ${idx + 1}`}
                  loading={idx === 0 ? 'eager' : 'lazy'}
                />
              ) : (
                <S.PlaceholderSlide>
                  <FaImage />
                  <span>{img.alt || `[PLACEHOLDER] Imagen ${idx + 1}`}</span>
                </S.PlaceholderSlide>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </S.MainSwiperWrapper>
    </S.GalleryContainer>
  );
};

export default GallerySwiper;
